<template>
  <SurveyFrontEnd
    type="result"
    :title="title"
    :content="content"
    :btn-text="btnText"
    :image-src="imageSrc"
    :btn-url="btnUrl"
    :style="themeColor"
  />
</template>

<script>
import '@/assets/css/te-cutsom.min.css';
import { mapState } from 'vuex';
import comTools from '@/tools/com';
import SurveyFrontEnd from '@/components/SurveyFrontEnd.vue';

export default {
  name: 'Result',
  components: {
    SurveyFrontEnd
  },
  data() {
    return {
      title: undefined,
      content: undefined,
      btnText: undefined,
      imageSrc: undefined,
      btnUrl: undefined
    };
  },
  created() {
    if (this.surveyTemplateData) {
      const { formInfo } = this.surveyTemplateData;
      this.title = comTools.getFormInfo(formInfo, 'EndPage_Title');
      const desc = comTools.getFormInfo(formInfo, 'EndPage_Desc');
      if (desc) {
        this.content = desc
          .replace(/\r\n/g, '<br />')
          .replace(/\r/g, '<br />')
          .replace(/\n/g, '<br />');
      }
      this.btnText = comTools.getFormInfo(formInfo, 'EndPage_ButtonName');
      this.imageSrc = comTools.getFormInfo(formInfo, 'EndPage_Image');
      this.btnUrl = comTools.getFormInfo(formInfo, 'EndPage_ButtonURL');
    } else {
      this.$router.push({ name: 'Invaild' });
    }
  },
  computed: {
    ...mapState('formSetting', ['bgColor', 'themeColor']),
    ...mapState('form', ['surveyTemplateData'])
  }
};
</script>
